import axios from "./axiosConfig";

const certificadosService = {
  getByMonth(year, month) {
    return axios.get("/certificados", { params: { year, month } });
  },

  emitir({ pestReportId, normas, empresa }) {
    return axios.post("/certificados", { pestReportId, normas, empresa });
  },

  getByFolio(folio) {
    return axios.get(`/certificados/folio/${encodeURIComponent(folio)}`);
  },
};

export default certificadosService;
